import { SettingConst } from '../../types';

/**
 * Controls preloading of search results on logged-in search page suggestion hover to improve response time
 */
export const LISP_SUGGESTION_HOVER_SPECULATION_241118 =
  'LISP_SUGGESTION_HOVER_SPECULATION_241118' as SettingConst<
    'LISP_SUGGESTION_HOVER_SPECULATION_241118',
    boolean,
    'RETAILER'
  >;
